import { render, staticRenderFns } from "./PwaApcnPopupTableInfo1.vue?vue&type=template&id=52c80709&"
import script from "./PwaApcnPopupTableInfo1.vue?vue&type=script&lang=js&"
export * from "./PwaApcnPopupTableInfo1.vue?vue&type=script&lang=js&"
import style0 from "./PwaApcnPopupTableInfo1.vue?vue&type=style&index=0&id=52c80709&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports